import * as React from 'react';

import TextfieldUnit from '../../../../../../components/TextfieldUnit';

import ACTIONS from '../../../../../../../redux/action';
import prices from '../prices.json';
import { useSelector, useDispatch } from 'react-redux';
import classes from '../../PricingTab.module.scss';

import i18n from '../../../../../../../utils/i18n';

import { providerLegalEntityFounding } from '../../../../../../,,/../data/providerText';

const FoundingPricing = () => {
	const dispatch = useDispatch();
	const foundingPrice = useSelector((state) => state.provider_founding_price);
	const isMobile = window.innerWidth < 480;
	const handleChange = (event, storeObj) => {
		let value = event.target.value;
		dispatch(
			ACTIONS.addProviderInfo({
				id: event.target.id,
				data: value,
				stateObject: storeObj,
			})
		);
	};

	return (
		<div
			style={{
				display: 'grid',
				gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)',
				gap: '16px',
				width: '100%',
			}}>
			{providerLegalEntityFounding().map((item) => {
				return (
					<div className={classes.textfieldColumn} key={item.id}>
						<TextfieldUnit
							id={item.id}
							title={item.label}
							isRequired={true}
							showAsterix={true}
							unit={`${i18n.t('general.currency')}`}
							value={foundingPrice[item.id]}
							onChange={(event) =>
								handleChange(event, 'provider_founding_price')
							}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default FoundingPricing;
